import BarChartIcon from '@mui/icons-material/BarChart'
import FolderSharedIcon from '@mui/icons-material/FolderShared'
import InsightsIcon from '@mui/icons-material/Insights'
import MedicationIcon from '@mui/icons-material/Medication'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import VaccinesIcon from '@mui/icons-material/Vaccines'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { routeBackOfficeCompanionAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeCompanionAdminCommon'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'
import { CountryEnum } from '@/types/enum/enumUser'

const getBackOfficeCareAdmin = [
  // Le « Tableau de bord » Care pointait sur /backoffice/care/dashboard-admin, une variante
  // Care du dashboard generique (taches CRM / raccourcis / stats / procedures). Cette page a
  // ete supprimee : l'entree retombe sur le dashboard admin commun et les statistiques Care
  // vivent desormais sur leur page dediee ci-dessous.
  ...routeBackOfficeAllEntityAdminCommon,
  ...routeBackOfficeCompanionAdminCommon,
  // Statistiques Care : page dediee, seul point d'entree cote menu.
  {
    route: 'CareStatisticsAdmin',
    text: 'Statistiques',
    t: 'routes.backoffice.care.statistics',
    icon: BarChartIcon,
    href: '/backoffice/care/statistics',
    menuHeader: true,
    position: 85,
  },
  // Fréquentation des officines, mesurée sur les lectures de carte Vitale du companion.
  {
    route: 'AttendanceAdmin',
    text: 'Fréquentation',
    t: 'routes.backoffice.care.attendance',
    icon: QueryStatsIcon,
    href: '/backoffice/care/attendance',
    menuHeader: true,
    position: 80,
  },
  // Statistiques des missions (sevrage, vaccination, bilan de prévention), agrégées comme la
  // fréquentation : une pharmacie, ou tout le parc / un groupement.
  {
    route: 'CareMissionStatisticsAdmin',
    text: 'Statistiques des missions',
    t: 'routes.backoffice.care.missionStatistics',
    icon: InsightsIcon,
    href: '/backoffice/care/mission-statistics',
    menuHeader: true,
    position: 82,
  },
  // Bibliothèque des ressources communes Care (super admin uniquement).
  {
    route: 'CareLibraryAdmin',
    text: 'Bibliothèque',
    icon: FolderSharedIcon,
    href: '/backoffice/care/library-admin',
    menuHeader: true,
    position: 90,
  },
  // Registre des règles vaccination V2, relu et validé par un pharmacien. Le référentiel ne
  // couvre que la France.
  {
    route: 'CareVaccinationRulesAdmin',
    text: 'Règles Vaccination',
    t: 'routes.backoffice.care.vaccinationRules',
    icon: VaccinesIcon,
    href: '/backoffice/care/vaccination-rules',
    menuHeader: true,
    position: 95,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
  // Référentiel des vaccins V2 et de leurs spécialités (AMM, CIS, CIP13, prix, sources), en
  // lecture seule. France uniquement, comme le registre des règles.
  {
    route: 'CareVaccinationCatalogAdmin',
    text: 'Référentiel vaccins',
    t: 'routes.backoffice.care.vaccinationCatalog',
    icon: MedicationIcon,
    href: '/backoffice/care/vaccination-catalog',
    menuHeader: true,
    position: 96,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDICARE],
  roles: [CONSTANTS.ROLE_SUPER_ADMIN],
}))

export default getBackOfficeCareAdmin
